import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { workflowSchemeProjectsLimitsResource } from '@jira/router-resources__admin-pages-performance/src/workflowSchemeProjectsLimitsResource.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceWorkflowSchemeProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceWorkflowSchemeProjectLimitRoute.tsx';
import { workflowSchemeProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/workflow-scheme/project-limit/WorkflowSchemeProjectLimitEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

const getWorkflowSchemeProjectLimitResources = () =>
	fg('slt1-1399_site_optimizer_workflow_scheme_metric')
		? [
				...getNavigationResources(),
				navigationSidebarGlobalResource,
				workflowSchemeProjectsLimitsResource,
			]
		: [...getNavigationResources(), navigationSidebarGlobalResource];

export const globalSettingsPerformanceWorkflowSchemeProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformanceWorkflowSchemeProjectLimitRoute,
	() => ({
		group: 'global-settings',

		canTransitionIn: () => fg('slt1-1399_site_optimizer_workflow_scheme_metric'),

		entryPoint() {
			if (!fg('slt1-1399_site_optimizer_workflow_scheme_metric')) {
				return notFoundPageEntrypoint;
			}
			return workflowSchemeProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: getWorkflowSchemeProjectLimitResources(),

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
